import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getSimCardsRequest, setSimcardSelected, setStateSimcards } from '../../actions/simcards';
import { filtersSimcardsToUseInQuerySelector } from '../../selectors/filters';
import { setSimcardsFilters } from '../../actions/filters';
import { simCardSelector } from '../../selectors/simcards';
import { gpsSelector } from '../../selectors/gps';
import SimcardLoader from './SimcardLoader';
import { getGpsDevicesRequest } from '../../actions/gps';

const mapStateToProps = createStructuredSelector({
    simCard: simCardSelector,
    filtersToUseInQuery: filtersSimcardsToUseInQuerySelector,
    gps: gpsSelector
});
const mapDispatchToProps = {
    getSimCardsRequest,
    setSimcardSelected,
    setStateSimcards,
    setSimcardsFilters,
    getGpsDevicesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(SimcardLoader);
